const breadCrumb = "Lançamento de Notas - Lançamento de Aspectos Socioafetivos";

const routes = [
  {
    path: "/permitir-lancamento-aspectos-socioafetivos-turma",
    name: "permitir-lancamento-aspectos-socioafetivos-turma",
    meta: {
      allowedPermissions: [
        "turma_aspectos_socioafetivos_list",
        "turma_aspectos_socioafetivos_alunos_list",
        "turma_aspectos_socioafetivos_alunos_create",
        "turma_aspectos_socioafetivos_alunos_delete",
      ],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/PermitirLancamentoDeAspectosSocioafetivosPorTurma/PermitirLancamentoDeAspectosSocioafetivosPorTurma.vue"
      ),
  },
  {
    path: "/permitir-lancamento-aspectos-socioafetivos-turma/:id",
    name: "permitir-lancamento-aspectos-socioafetivos-turma-lancar",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/PermitirLancamentoDeAspectosSocioafetivosPorTurma/LancamentoAspectosSocioafetivosTurma.vue"
      ),
  },
  {
    path: "/permitir-lancamento-aspectos-socioafetivos-turma/:id/editar",
    name: "permitir-lancamento-aspectos-socioafetivos-turma-editar",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/PermitirLancamentoDeAspectosSocioafetivosPorTurma/PermitirLancamentoDeAspectosSocioafetivosPorTurmaEditar.vue"
      ),
  },
];

export default routes;
